/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Md_DiagramInputs */

const en_md_diagram = /** @type {(inputs: Md_DiagramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagram`)
};

const id_md_diagram = /** @type {(inputs: Md_DiagramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagram`)
};

/**
* | output |
* | --- |
* | "Diagram" |
*
* @param {Md_DiagramInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const md_diagram = /** @type {((inputs?: Md_DiagramInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Md_DiagramInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_md_diagram(inputs)
	return en_md_diagram(inputs)
});